// extracted by mini-css-extract-plugin
module.exports = {"featured_override":"ProductLayout_featured_override__S1ZKi","heroWrapper":"ProductLayout_heroWrapper__3ZkuV","mw_1500":"ProductLayout_mw_1500__wEVR7"};